import { isNil, omitBy, isEmpty } from "lodash";
import moment from "moment";

const constructDate = (date, format?) => {
  if (!date) return null;

  const isMoment = moment(date, format).isValid();

  if (!isMoment) return null;

  return moment(date, format);
};

const constructData = (params) => {
  // locations must be similar to order-settings.ts
  const dLocations = params.locations.map((l) => l.code);

  const { surcharge } = params || {};

  return {
    ...params,
    cutOffTime: constructDate(params.cutOffTime, "HH:mm"),
    estimatedTime: constructDate(params.estimatedTime, "HH:mm"),
    locations: dLocations,
    locationsData: params.locations,
    rates: params.rates,
    validFrom: constructDate(params.validFrom),
    validTo: constructDate(params.validTo),
    surchargeType: params.surchargeType,
    surchargeFixedAmount: surcharge?.fixedAmount,
    surchargePercentage: surcharge?.percentage,
    surchargeCapAmount: surcharge?.capAmount,
  };
};

const response = (params) => {
  const normalisedData = constructData(params.data);

  const results = omitBy(
    {
      ...params,
      data: null,
      ...normalisedData,
    },
    isNil,
  );

  return results;
};

export default response;
